import { render } from "./IntroYoutube.vue?vue&type=template&id=71a6245c&scoped=true"
import script from "./IntroYoutube.vue?vue&type=script&lang=js"
export * from "./IntroYoutube.vue?vue&type=script&lang=js"

import "@/css/layerPop.scss?vue&type=style&index=0&id=71a6245c&scoped=true&lang=scss"
import "./IntroYoutube.vue?vue&type=style&index=1&id=71a6245c&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a6245c"]])

export default __exports__